import {ComponentProps} from 'react';

import {Spinner, view} from '@sail/ui';

function SpinnerRow({
  size,
  invisible = false,
}: {
  size?: ComponentProps<typeof Spinner>['size'];
  invisible?: boolean;
}) {
  return (
    <view.div
      data-testid="SpinnerRow"
      css={{
        display: 'flex',
        justifyContent: 'center',
        marginY: 'medium',
        width: '100%',
        opacity: invisible ? 0 : 1,
      }}
    >
      <Spinner size={size} />
    </view.div>
  );
}

export function LoadingScreen() {
  return (
    <view.div
      data-testid="loading-screen"
      css={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <SpinnerRow size="large" />
    </view.div>
  );
}
